import { aiListingFields } from '../config/configListing';

/**
 * Marketplace category labels by locale for a listing publicData.category option.
 * Mirror server getMarketplaceLabelsByOption in server/api-util/storeCategoryHelpers.js
 * (source of truth: server/api/data marketplaceCategories — keep aiListingFields category enum in sync).
 *
 * @param {string} option - Marketplace option key (same as publicData.category)
 * @returns {Object} { en, fr, es, zh } string values (may be empty object if unknown)
 */
export function getMarketplaceLabelsByOptionFromConfig(option) {
  const field = (aiListingFields || []).find(f => f.key === 'category');
  const item = field?.enumOptions?.find(o => o.option === option) || null;
  if (!item) return {};
  const labels = item.labels || {};
  const base = item.label || null;
  return {
    en: labels.en || base,
    fr: labels.fr || base,
    es: labels.es || base,
    zh: labels.zh || base,
  };
}

/**
 * Returns true only if `option` matches one of the marketplace category enum keys.
 * Use this to validate AI-generated suggested_category before storing it.
 */
export function isValidMarketplaceCategory(option) {
  if (!option) return false;
  const field = (aiListingFields || []).find(f => f.key === 'category');
  return !!(field?.enumOptions?.some(o => o.option === option));
}
